<script setup>
// const qrArr = [
//   {
//     img: 'https://p2.ssl.qhimg.com/t0162c3aef5b6d4240a.png',
//     title: 'ISC APP下载'
//   },
//   {
//     img: 'https://p1.ssl.qhimg.com/t01a6c938031f8dfc0e.png',
//     title: '微信公众号'
//   }
// ]
</script>
<template>
  <div class="about">
    <div class="aboutTitle">关于我们</div>
    <div class="aboutNav">
      <!-- <p class="aboutNavTitle">关于ISC</p> -->
      <div class="aboutNavDesc">
        ISC（三六零数字安全科技集团有限公司）成立于2013年，是国内专注为数字安全行业赋能的平台。打造集会展服务、咨询服务、媒体服务、生态创投、生态联盟、产业导入“六维一体”的生态模式，全面赋能国家、政府、行业、企业、个人。过去10年，ISC创办了亚太地区乃至当今世界历史悠久、规格高、辐射广、影响力深远的全球性安全峰会——互联网安全大会，致力于挖掘极具前瞻性的安全观点和发展趋势，凭借高规格和高质量的会、展、赛等形式，深刻影响着产业发展，目前已成为中国网络安全产业风向标。
      </div>
      <!-- <img class="aboutNavImg" src="https://p3.ssl.qhimg.com/t110b9a93016bb1d9ebff6b497c.png" alt="" />
      <p class="aboutNavDesc">
        “观潮”是中国首先推出多方网络空间智库品牌。由360公司、中国国际战略学会、中国创新与发展战略研究会发起，并在2016年互联网安全大会（ISC2016）期间举办了首次会议。首届论坛邀请了来自美国、俄罗斯、欧盟、中国的多名发言人以及来自政府、企业、军队的多位学者，围绕全球互联网治理体系和网络空间规范等问题展开对话。
      </p>
      <p class="aboutNavDesc">使命：促进网络空间创新、安全、交流、合作。</p> -->
      <div class="aboutNavQr">
        <!-- <p v-for="item in qrArr" :key="item.title">
          <img :src="item.img" alt="" />
          <span>{{ item.title }}</span>
        </p> -->
      </div>
      <div class="aboutNavMessage">
        <p>
          ISC.AI 商务合作 <br />
          马欣：15718876610 <br />
          ISC.AI 学苑合作 <br />
          吕雯雯：13581715706 <br />
        </p>
        <p>
          微信：ISC平台 <br />邮箱：ISC@360.cn<br />
          投诉通道：ISC@360.cn <br />互联网安全大会
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.about {
  background: #e9f1ff;
  padding: 40px 12px 0;
  &Title {
    position: relative;
    background: url('https://p3.ssl.qhimg.com/t01dfa26c934332d886.png') no-repeat;
    background-size: 136px 32px;
    text-align: center;
    margin: auto;
    margin-bottom: 24px;
    width: 136px;
    height: 32px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 32px;
    img {
      width: 100%;
    }
  }
  &Nav {
    padding: 0 10px;
    &Title{
      font-size: 20px;
      font-weight: bold;
      color: #222222;
      margin-bottom: 8px;
    }
    &Desc {
      font-size: 14px;
      color: #4a506b;
      line-height: 24px;
      // padding: 0 10px;
      text-align: justify;
    }
    &Img{
      width: 80px;
      margin-top: 28px;
      margin-bottom: 12px;
    }
    &Qr {
      display: flex;
      justify-content: space-between;
      margin: 0 5px;
      p {
        text-align: center;
        font-size: 12px;
        color: #222222;
      }
      img {
        display: block;
        width: 151px;
        margin-bottom: 8px;
      }
    }
    &Message {
      display: flex;
      justify-content: space-between;
      margin: 40px 0 0;
      padding-bottom: 40px;
      p {
        width: 148px;
        font-size: 13px;
        color: #4a506b;
        line-height: 24px;
      }
    }
  }
}
</style>
